import {isTouching} from './is'

const $window = $(window)

function checkLineIntersection(line1, line2) {
	// if the lines intersect, the result contains the x and y of the
	// intersection (treating the lines as infinite) and booleans for whether
	// line segment 1 or line segment 2 contain the point
	var result = {
		x: null,
		y: null,
		onLine1: false,
		onLine2: false
	}
	const denominator = ((line2.y2 - line2.y1) * (line1.x2 - line1.x1)) - ((line2.x2 - line2.x1) * (line1.y2 - line1.y1))
	if (denominator === 0) {
		return result
	}
	let a = line1.y1 - line2.y1
	let b = line1.x1 - line2.x1
	const numerator1 = ((line2.x2 - line2.x1) * a) - ((line2.y2 - line2.y1) * b)
	const numerator2 = ((line1.x2 - line1.x1) * a) - ((line1.y2 - line1.y1) * b)
	a = numerator1 / denominator
	b = numerator2 / denominator

	// if we cast these lines infinitely in both directions, they intersect here:
	result.x = line1.x1 + (a * (line1.x2 - line1.x1))
	result.y = line1.y1 + (a * (line1.y2 - line1.y1))
	/*
		// it is worth noting that this should be the same as:
		x = line2.x1 + (b * (line2.x2 - line2.x1));
		y = line2.x1 + (b * (line2.y2 - line2.y1));
	*/

	if (a > 0 && a < 1) {
		result.onLine1 = true
	}
	// if line2 is a segment and line1 is infinite, they intersect if:
	if (b > 0 && b < 1) {
		result.onLine2 = true
	}
	// if line1 and line2 are segments, they intersect if both of the above are
	// true
	return result
}

export const $canvas = $(document.createElement('canvas'))
const context = $canvas.get(0).getContext('2d')

$(document.body).append($canvas)
$canvas.css({
	'position': 'fixed',
	'top': 0,
	'left': 0,
	'width': '100%',
	'height': '100%',
	'z-index': '10000',
	'pointer-events': 'none'
})
$canvas.attr('width', $(window).width())
$canvas.attr('height', $(window).height())

function clear() {
	context.clearRect(0, 0, context.canvas.width, context.canvas.height)
}

function drawPoint(x, y, color) {
	context.fillStyle = color || 'black'
	context.beginPath()
	context.arc(x, y, 5, 0, 2 * Math.PI, true)
	context.fill()
}

function drawLine(line, color) {
	color = color || 'black'
	context.strokeStyle = color
	context.beginPath()
	context.moveTo(line.x1, line.y1)
	context.lineTo(line.x2, line.y2)
	context.stroke()
	drawPoint(line.x1, line.y1, color)
	drawPoint(line.x2, line.y2, color)
}

export function MouseBasedMenuManager({$rootContainer, $menu, $label, $toggle, onLabelClickVisit}) {
	function onMouseEnter(e) {
		if (isTouching()) {
			return
		}

		if (!$toggle.prop('checked')) {
			$toggle.prop('checked', true)
			$toggle.one('click', onClick)
			$label.one('mouseleave', onMouseLeave)
			$rootContainer.one('mouseleave', onMouseLeaveRoot)

			$window.trigger('mbmm:onMenuOpened', $menu)

			function onIntentToClose() {
				$toggle.prop('checked', false)
				$toggle.off('click', onClick)
				$label.off('mouseleave', onMouseLeave)
				$rootContainer.off('mouseleave', onMouseLeaveRoot)
				$window.off('mousemove', onMouseMove)
			}

			let intentToClose

			function onMouseMove(e) {
				const $target = $(e.target)
				const isLabel = $target.is($label) || $label.has($target).length

				const bcrLabel = $label.get(0).getBoundingClientRect()
				const bcr = $menu.get(0).getBoundingClientRect()

				const line1 = {
					x1: bcrLabel.left + bcrLabel.width / 2,
					y1: bcrLabel.top + bcrLabel.height / 2,
					x2: e.clientX,
					y2: e.clientY
				}
				const line2 = {
					x1: bcr.left,
					y1: bcr.top,
					x2: bcr.right,
					y2: bcr.top
				}

				// clear()
				// drawLine(line1, 'red')
				// drawLine(line2, 'green')
				const result = checkLineIntersection(line1, line2)
				if (!result.onLine2 && !isLabel) {
					clearTimeout(intentToClose)
					intentToClose = setTimeout(onIntentToClose, 50)
				} else {
					// drawPoint(result.x, result.y, 'blue')
					clearTimeout(intentToClose)
				}
			}

			function onMouseLeave(e) {
				if (!$(e.relatedTarget).is($menu)) {
					$window.on('mousemove', onMouseMove)
				}
			}

			function onMouseLeaveRoot(e) {
				$toggle.prop('checked', false)
			}

			function onClick(e) {
				if (isTouching()) {
					return
				}

				e.preventDefault()
				e.stopPropagation()
				window.location.href = onLabelClickVisit
			}
		}
	}

	function onMenuOpened(e, $menuJustOpened) {
		if (!$menu.is($menuJustOpened)) {
			$toggle.prop('checked', false)
		}
	}

	return {
		start() {
			$label.on('mouseenter', onMouseEnter)
			$window.on('mbmm:onMenuOpened', onMenuOpened)
		},
		stop() {
			$label.off('mouseenter', onMouseEnter)
			$window.off('mbmm:onMenuOpened', onMenuOpened)
		}
	}
}